/* eslint-disable @typescript-eslint/no-explicit-any */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import * as Qs from 'qs'

export class ModelQueryBuilder {
  protected $url: string

  constructor(url: string) {
    this.$url = url
  }

  push(data: { [key: string]: string | number | boolean | { [key: string]: any } }): void {
    const query = Qs.stringify(data, { arrayFormat: 'brackets' })

    this.$url = this.hasQueryAlready ? `${this.$url}&${query}` : `${this.$url}?${query}`
  }

  public get hasQueryAlready(): boolean {
    return this.$url.includes('?')
  }

  public get url(): string {
    return this.$url
  }

  public set url(url: string) {
    this.$url = url
  }
}
